import React from 'react';
import BlogForm from './BlogForm';

function BlogModal(props) {
    return (
        <>
            <div
                className="modal fade my-5"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">
                                Post your Pitch
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <BlogForm email={props.email} state={props.state} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BlogModal;
